import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Services } from '@/services/services';
import { CurrentSession } from '@/services/repository/session';
import { Roles } from '@/services/repository/users';
import { VerifyEmailFormData } from './step1/VerifyEmail.form';
import { VerifyEmailPage } from './step1/VerifyEmail';
import { NewPasswordPage } from './step2/NewPassword';
import { Translates } from '@/services/repository/i18n';

import './wizard.css'

export const ResetPasswordWizard = ({ services }: { services: Services }) => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token")
  const [data, setData] = useState<VerifyEmailFormData>()
  const [translates, setTranslates] = useState<Translates>()

  useEffect(() => {
    if (token === undefined || token === null) {
      return
    }
    fetch(`/api/schema/users/resetpassword/verifyemail/bytoken?token=${token}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((resp) => {
      return resp.json()
    }).then((respData: VerifyEmailFormData) => {
      setData(respData)
    })
  }, [token])

  useEffect(() => {
    services.i18n.get('main').then(setTranslates)
  }, [])

  const loadStep = () => {
    if (!token) {
      return <VerifyEmailPage services={services} />
    } else if (data === undefined) {
      return <div className='spinner'></div>
    } else if (data.email) {
      return <NewPasswordPage data={data} token={token} services={services} />
    } else {
      return <div>Error</div>
    }
  };

  return (
    <div className="dashboard resetpassword-wizard">
      {loadStep()}

      <div className='support-wrap' onClick={() => navigate('/communal/support/wizard')}>
        {translates?.for('layout.support_page')}
      </div>
    </div>
  );
};
